import { useCallback, useState, useEffect } from "react";
import { useVisible } from "../../../../../utils/hooks/useVisible";

const getKeyIdentifier = ({ id }: any) => {
    return id;
};

export const useColumnToggleUserPreferences = (baseColumns: any[]) => {
    const { visible, toggle, close } = useVisible();

    const getMap = useCallback((columns: any[]) => {
        return columns.reduce((total: any, column: any) => {
            const key = getKeyIdentifier(column);
            return {
                ...total,
                [key]: column.getIsVisible(),
            };
        }, {})
    }, []);

    const [visibleColumns, setVisibleColumns] = useState(getMap(baseColumns));

    const onVisibilityChange = useCallback((key: string) => {
        setVisibleColumns((prev: any) => ({
            ...prev,
            [key]: !prev[key],
        }));
    }, [setVisibleColumns]);

    useEffect(() => {
        setVisibleColumns(getMap(baseColumns));
    }, [baseColumns, setVisibleColumns]);

    const onSave = useCallback(async ({ columns, submit }: { columns: any[]; submit: (config: any) => Promise<any> }) => {
        const cols = columns.map((column) => {
            const key = getKeyIdentifier(column);
            return {
                accessor: key,
                hide: !visibleColumns[key],
            };
        });
        await submit({ columns: cols });
        close();
    }, [visibleColumns, close]);

    return {
        visibleColumns,
        onVisibilityChange,
        getKeyIdentifier,
        onSave,
        visible,
        toggle,
    };
}
